import * as core from '../../../../../../../core'

import { query } from './institutional-risk-assessments-table.query'

export const RESOURCE = {
  payload: {
    alias:
      'sr.subrecipient-details.widgets.institutional-risk-assessments-table',
    description: 'Institutional Risk Assessments',
    name: 'Institutional Risk Assessments',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
